module.exports = __webpack_public_path__ + "img/1529786720.739cbbc8.jpg";